import React from 'react';
import { Container, Paper, Typography } from '@mui/material';

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={4} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Last updated: 02 08 2026
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          1. Overview
        </Typography>
        <Typography variant="body1" gutterBottom>
          This Privacy Policy explains how we collect, use, and protect your information when you use Incooking Growth Hub.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          2. Information We Collect
        </Typography>
        <Typography variant="body1" gutterBottom>
          We may collect account information (such as email), Meta account identifiers, and usage data necessary to provide the service.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          3. How We Use Information
        </Typography>
        <Typography variant="body1" gutterBottom>
          We use your information to authenticate you, connect Meta accounts, and deliver scheduling and analytics features.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          4. Data Sharing
        </Typography>
        <Typography variant="body1" gutterBottom>
          We only share data with Meta APIs as required to connect and manage your accounts. We do not sell your data.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          5. Security
        </Typography>
        <Typography variant="body1" gutterBottom>
          Access tokens are encrypted at rest. We use reasonable safeguards to protect your data.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          6. Contact
        </Typography>
        <Typography variant="body1" gutterBottom>
          For questions, contact us at privacy@example.com.
        </Typography>
      </Paper>
    </Container>
  );
}
